import {
  Component,
  OnInit,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {GoogleTagService} from 'src/app/data/networking/services/shared/google-tag/google-tag.service';
import {Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {PageEvent} from '../../event-listeners/event-page/event-page.event';

@Component({
  selector: 'app-carousel-ftd',
  templateUrl: './carousel-ftd.component.html',
  styleUrls: ['./carousel-ftd.component.scss'],
})
export class CarouselFtdComponent implements OnInit, OnChanges {
  optionsArrows = true;
  scrollPixel = 0;
  scrollToItem = 0;
  nextItems = 0;
  arrows = {
    left: {
      disabled: false,
      show: true,
    },
    right: {
      disabled: false,
      show: true,
    },
  };

  @Input() componentType;
  @Input() arrayProducts = [];
  @Input() spaceDelete = 0;
  @Input() config: any;
  @Input() miniCard = false;
  @Input() isHome = false;
  @Input() isVTO = false;
  @Input() isFlashOffer = false;
  @Input() idPrefix = '';
  @Input() origin = '';
  @Input() gtmList = '';
  @Input() gtmPreprocessor;
  @Input() navigation = true;
  @Input() rows = 1;
  @Input() dataLoaded = false;
  @Input() isSustitutes = false;
  @Input() videoOnly = false;
  @Input() smallArrow = false;
  @Input() imageContent = false;
  @Input() customStyle = {};
  @Input() shortcuts;
  @Input() isDermo = false;
  @Input() isGroup = false;
  @Input() isCarousel = false;
  @Input() discountsLoaded = true;
  @Input() groupType = '';

  sendGtm = true;
  charge = false;
  isBrowser;
  performanceActive = true;
  isMobile = window.screen.width <= 991;
  transformedProducts = [];

  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;

  private normalizeUrl(url: string): string {
    return url.replace(/^https?:\/\/[^\/]+/, '');
  }

  constructor(
    private gtmService: GoogleTagService,
    private eventPage: PageEvent,
    private router: Router,
    @Inject(PLATFORM_ID) platformId,
  ) {
    this.isBrowser = isPlatformBrowser(platformId) && !(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1);
  }

  ngOnInit(): void {
    this.eventPage.eventCallAllComponentsListener.subscribe((res: any) => {
      if (res.allComponents) {
        this.performanceActive = false;
      }
    });

    if (!this.videoOnly && this.arrayProducts?.length > 0) {
      this.arrayProducts = this.arrayProducts.filter(
        item => item?.mediaImageUrl && (item?.description || item?.mediaDescription),
      );
      this.arrayProducts = this.arrayProducts.filter(i => !i.outofstore);
    }

    if (this.shortcuts) {
      if (this.shortcuts !== undefined) {
        this.arrayProducts = this.shortcuts;
      }
    }

    this.assignClass();
  }

  next(event: Event) {
    event.stopPropagation();
    if (!this.arrows.right.disabled && this.scrollToItem <= this.arrayProducts?.length) {
      this.scrollToItem += this.nextItems;
      this.scrollTo();
    }
    return false;
  }

  back(event: Event) {
    event.stopPropagation();
    if (!this.arrows.left.disabled && this.scrollToItem > this.nextItems) {
      this.scrollToItem -= this.nextItems;
      this.scrollTo();
    }
    return false;
  }

  scrollTo() {
    if (this.virtualScroller) {
      this.virtualScroller.scrollToIndex(this.scrollToItem, null, null, 400, () => {});
    }
  }

  eventScroll(event) {
    if (this.optionsArrows && event.endIndex > 0 && this.arrayProducts?.length > 0) {
      this.nextItems = event.endIndex;
      this.scrollToItem = event.endIndex;
      this.optionsArrows = false;
    }
    if (event.endIndex > this.nextItems && event.endIndex <= this.arrayProducts?.length - 1) {
      this.arrows.left.disabled = false;
      this.arrows.right.disabled = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes
      && changes.arrayProducts
      && changes.arrayProducts.currentValue
      && changes.arrayProducts.currentValue.length > 0
    ) {
      this.assignClass();

      if (this.isBrowser) {
        if (this.sendGtm) {
          this.gtmService.onImpressions(
            changes.arrayProducts.currentValue,
            this.gtmList,
            this.gtmPreprocessor,
          );
          this.sendGtm = false;
        }

        setTimeout(() => {
          this.charge = true;
        }, 1000);
      } else {
        this.arrayProducts = this.arrayProducts.slice(0, 5);
      }
    }
  }

  goTo(item) {
    const title = item.title ? `-${this.urlFormatter(item.title)}` : '';
    const categorie = item.categorie ? `-${this.urlFormatter(item.categorie)}` : '';
    const urlGo = item.id + title + categorie;
    this.router.navigate(['/tutorial/', urlGo]);
  }

  urlFormatter = text => {
    if (!text) {
      return '';
    }

    return text
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/´/g, '')
      .replace(/ /g, '-')
      .replace(/--/g, '-')
      .replace(/[&\/\\#,]/g, '')
      .replace(/[+()$~%.'"]/g, '')
      .replace(/[:=*?]/g, '')
      .replace(/[!<>{}]/g, '');
  };

  handleRedirect(url: string): void {
    const externalUrls = new Set(['https://wa.me/', 'blog', 'trabajaconnosotros']);
    const isExternal = Array.from(externalUrls).some(externalUrl => url.includes(externalUrl));

    if (isExternal) {
      window.location.href = url;
    } else {
      const normalizedURL = this.normalizeUrl(url);
      const hasQueryParamsValidate = this.hasQueryParams(normalizedURL);

      hasQueryParamsValidate
        ? this.goInternalUrlWithQueryParams(normalizedURL)
        : this.goInternalUrlWithOutQueryParams(normalizedURL);
    }
  }

  hasQueryParams(url: string) {
    const hasParams = url.split('?').length > 1;
    return hasParams;
  }

  goInternalUrlWithQueryParams(url: string) {
    const urlSplit = url.split('?');
    const path = urlSplit[0];
    const queryParamsList = urlSplit[1]?.split('&') || [];
    const queryParams: any = {};

    queryParamsList.forEach(param => {
      const paramString = param.split('=');
      const key = decodeURIComponent(paramString[0]);
      const value = decodeURIComponent(paramString[1] || '');
      queryParams[key] = value;
    });

    this.router.navigate([path], {
      queryParams,
    });
  }

  goInternalUrlWithOutQueryParams(url: string) {
    this.router.navigate([url]);
  }

  assignClass() {
    if (this.groupType === 'suggests' && this.isMobile) {
      const transformedArray = [];
      for (let productIndex = 0; productIndex < this.arrayProducts.length; productIndex++) {
        if (productIndex % 5 === 0) {
          transformedArray.push({
            type: 'full',
            product: {
              ...this.arrayProducts[productIndex],
              isHalf: false,
              class: 'column-full',
            },
          });
        } else {
          const halfGroup = {
            type: 'half-group',
            products: [],
          };
          for (let halfGroupIndex = 0; halfGroupIndex < 2 && productIndex < this.arrayProducts.length; halfGroupIndex++, productIndex++) {
            if (productIndex % 5 === 0) {
              productIndex--;
              break;
            }
            halfGroup.products.push({
              ...this.arrayProducts[productIndex],
              isHalf: true,
              class: 'column-half',
            });
          }
          transformedArray.push(halfGroup);
          productIndex--;
        }
      }
      this.transformedProducts = transformedArray;
    } else {
      this.transformedProducts = this.arrayProducts;
    }
  }
}
